import React from 'react';
import { SvgIconProps } from '../type';
import useDesignTokens from '../../themes/useDesignTokens';

function CloseButton({
  width = 20,
  height = 20,
  color,
}: Readonly<SvgIconProps>) {
  const tokens = useDesignTokens();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke={color ?? tokens.components.button.tertiary.default.fg.default}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CloseButton;
